// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "flowbite/dist/flowbite.turbo.js";
import "pdfjs-viewer-element";
import * as echarts from "echarts";

window.echarts = echarts;

// For opening show modal by clicking the row or just visiting the URL
function handleTurboVisit(event, url, isModal = true) {
  const isLink = event.target.closest("a");

  if (isLink || event.target.closest(".disable-trigger")) {
    return;
  }

  if (isModal) {
    Turbo.visit(url, { frame: "modal" });
  } else {
    Turbo.visit(url, { frame: "main_content_frame", action: "advance" });
  }
}

// Available globally
window.handleTurboVisit = handleTurboVisit;
